import React from 'react';
import { Box, Button, Heading, Text, Flex } from '@chakra-ui/react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  handleReset = () => {
    localStorage.removeItem('token');
    this.setState({ hasError: false, error: undefined });
    window.location.href = '/auth/sign-in';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Flex minH="100vh" align="center" justify="center" bg="gray.50">
          <Box textAlign="center" p="40px">
            <Heading size="lg" mb="4">Something went wrong</Heading>
            <Text color="gray.500" mb="6">{this.state.error?.message}</Text>
            <Button colorScheme="brand" onClick={this.handleReset}>
              Return to Login
            </Button>
          </Box>
        </Flex>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
